import React from 'react';

import Error from '@gasbi/shared/web/components/ErrorBoundary/ErrorView';
import { Route, RouteObject, createBrowserRouter } from 'react-router-dom';

import Pages from '@/pages';

import NotFound from './pages/NotFound';
import AuthCallback from './pages/auth/AuthCallback';

const Router = React.lazy(() => import('@/pages/Router'));
const Home = React.lazy(() => import('@/pages/Home'));
const CabinetUsers = React.lazy(() => import('@/pages/CabinetUsers'));
const MyCompany = React.lazy(() => import('@/pages/MyCompany'));
const Contracts = React.lazy(() => import('@/pages/Contracts'));
const ContractDetails = React.lazy(() => import('@/pages/ContractDetails'));
const ExpiredDevices = React.lazy(() => import('@/pages/ExpiredDevices'));

const NotAuthorized = React.lazy(() => import('@/pages/NotAuthorized'));
const CommercialMeteringPointsDetails = React.lazy(
  () => import('@/pages/CommercialMeteringPointsDetails'),
);

const RepresentativeDetails = React.lazy(
  () => import('@/forms/RepresentativeForm'),
);

const DocumentsAndActs = React.lazy(() => import('@/pages/DocumentsAndActs'));

const notFoundRoute = {
  path: '*',
  element: <NotFound />,
};

export const routes: RouteObject[] = [
  {
    path: Pages.ROOT,
    element: <Home />,
  },
  {
    path: Pages.MY_COMPANY,
    element: <MyCompany />,
  },
  {
    path: Pages.REPRESENTATIVES,
    element: <CabinetUsers />,
    children: [
      {
        path: ':representativeId',
        element: <RepresentativeDetails />,
      },
    ],
  },
  {
    path: Pages.CONTRACTS,
    element: <Contracts />,
  },
  {
    path: `${Pages.CONTRACTS}/:contractId`,
    element: <ContractDetails />,
  },
  {
    path: `${Pages.CONTRACTS}/:contractId/:commercialMeteringPointId`,
    element: <CommercialMeteringPointsDetails />,
  },
  {
    path: Pages.DOCUMENTS_AND_ACTS,
    element: <DocumentsAndActs />,
  },
  {
    path: Pages.EXPIRED_DEVICES,
    element: <ExpiredDevices />,
  },
  notFoundRoute,
];

export const getNestedRoutes = (routes: RouteObject[]) => {
  return routes.concat(notFoundRoute).map(({ children, ...route }, index) => (
    // @ts-ignore
    <Route key={index} {...route}>
      {children?.length ? getNestedRoutes(children) : null}
    </Route>
  ));
};

export const getRoutes = () =>
  createBrowserRouter(
    [
      // Page for oidc authorization flow
      {
        path: Pages.AUTH_CALLBACK,
        element: <AuthCallback />,
      },
      {
        path: Pages.NOT_AUTHORIZED,
        element: <NotAuthorized />,
      },
      {
        path: '*',
        element: <Router />,
      },
    ].map(route => ({ ...route, errorElement: <Error /> })),
  );
